import React, { useState, useEffect } from "react";
import ShortNameBox from "../course/ShortNameBox";
import {getSubjectStatus, formatOnlyDateRange} from "../../utils/commonFunction";
import moment from "moment";
import Str from "../common/Str";
import { ProgramIcons } from "../course/CommonCourseComponents";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { GetCampusText, GetLearningMethodText } from "./ProgramHelperUtils.js";
import { programStyles } from "./ProgramStyles";

const stc = require('string-to-color');

const ProgramHeadBox = (props) => {
  const location = useLocation();
  const row = props.content;
  const [data, setData] = useState(null);

  

 const dateItems = [
  row?.start && row?.end
    ? formatOnlyDateRange(row.start, row.end)
    : null,

  row?.number && row?.year
    ? `Intake ${row.number}, ${row.year}`
    : null,
].filter(Boolean);

const hasDateGroup = dateItems.length > 0;
const hasType = !!row?.type;
const hasLocation = !!row?.campus;
const hasLocationGroup = hasType || hasLocation;
const typeLocationText =
  [
    row?.type ? GetLearningMethodText(row.type) : null,
    row?.campus ? GetCampusText(row.campus) : null,
  ]
    .filter(Boolean)
    .join(" - ");

  return (
    <div>
      <div
        title={row.course} style={programStyles.programHead}>
        {row.course}
      </div>
      <div style={programStyles.programInfoRow}>
        {hasDateGroup && (
          <>
            <i
              className="fa-light fa-calendar-clock"
              style={{ marginRight: "4px" }}
            />
            {dateItems.join(" | ")}
          </>
        )}
        {hasDateGroup && hasLocationGroup && " | "}
        {hasLocationGroup && (
          <>
            <i
              className="fa-light fa-building-columns"
              style={{ marginLeft: "4px", marginRight: "4px" }}
            />
            {typeLocationText}
          </>
        )}
      </div>
    </div>
  );
}
export default ProgramHeadBox;
